import { AddedAIToBoundPolicyNotification } from "./Shared/TopBarNotification";
import { Assert } from "Tools";
import React from "react";
import { HeaderHamburger } from "./HeaderHamburger";

const namedComponentTable: {
  [K: string]: (props: any) => JSX.Element;
} = {
  AddedAIToBoundPolicyNotification,
  HeaderHamburger,
};

export interface NamedComponentProps {
  ComponentName: string;
  Props: any;
  [K: string]: any;
}

export function NamedComponent({
  ComponentName,
  Props,
  ...extraProps
}: NamedComponentProps) {
  const Component = namedComponentTable[ComponentName];
  Assert.hard(!!Component, `Component ${ComponentName} not found`);
  return <Component {...Props} {...extraProps} />;
}
